module.exports = __webpack_public_path__ + "img/question.df174033.svg";